import { combineEpics, ofType } from 'redux-observable'
import { of } from 'rxjs'
import { catchError, mergeMap, takeUntil } from 'rxjs/operators'

import { fetchSegments } from '../../actions'

import { editError, editSuccess } from './actions'
import { EDIT_ASYNC } from './constants'

const editEpic = (action$, state$, { api, epicsErrorHandler }) =>
  action$.pipe(
    ofType(EDIT_ASYNC.INITIATE),
    mergeMap((action) =>
      api.mailboxes
        .updateSegment(state$.value.partnerOptions.selectedCompany?.value, {
          id: action.payload.id,
          name: action.payload.name,
          included_tags: action.payload.includedTags,
          excluded_tags: action.payload.excludedTags,
        })
        .pipe(
          mergeMap(({ response }) =>
            response.success
              ? of(fetchSegments(), editSuccess(response || {}))
              : of(editSuccess(response || {}))
          ),
          catchError((error) => of(epicsErrorHandler(editError, error))),
          takeUntil(action$.pipe(ofType(EDIT_ASYNC.CANCEL)))
        )
    )
  )

export default combineEpics(editEpic)
